import 'twin.macro';
import React from 'react';
import { bgColors } from '@teetsh/app/src/components/colors';
import { BgColor, Color } from '@teetsh/app/src/types/colors';

interface Props {
  className?: string;
  title?: string;
  bgColor?: Color | BgColor;
}

export function Divider(props: Props) {
  const { className, title, bgColor = 'white' } = props;
  return (
    <div tw="relative" className={className}>
      <div tw="absolute inset-0 flex items-center" aria-hidden="true">
        <div tw="w-full border-t border-neutral-quiet" />
      </div>
      <div tw="relative flex justify-center">
        <span css={[bgColors(bgColor)]} tw="px-2 text-sm text-neutral-quiet">
          {title}
        </span>
      </div>
    </div>
  );
}
